import { clamp } from '@helpers/utils';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './DesktopNavigation.styles';
import NavigationDropdown from './NavigationDropdown/NavigationDropdown';
const DesktopNavigation = (props) => {
    const linkRef = React.useRef([]);
    return (React.createElement(S.Container, { onMouseLeave: () => props.setActiveLink('') }, props.links.map((link, i) => (React.createElement(React.Fragment, { key: link.id },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.NavigationLink, { ref: (el) => (linkRef.current[i] = el), id: `${link.id}-parent`, href: link.url, target: link.target, "data-active": props.activeLink === link.id, onMouseEnter: () => {
                    if (!props.searchOpen) {
                        props.setActiveLink(link.id);
                    }
                }, onFocus: () => props.setActiveLink(link.id), onKeyDown: (event) => {
                    const maxIndex = props.links.length - 1;
                    const nextIndex = i === maxIndex ? 0 : clamp(i + 1, maxIndex);
                    const prevIndex = i === 0 ? maxIndex : clamp(i - 1, maxIndex);
                    switch (event.key) {
                        case 'ArrowDown':
                            if (link.children.length > 0) {
                                props.setActiveLink(link.id);
                                document.getElementById(`${link.children[0].id}-main-link`)?.focus();
                            }
                            break;
                        case 'ArrowUp':
                            props.setActiveLink('');
                            break;
                        case 'ArrowRight':
                            event.preventDefault();
                            event.stopPropagation();
                            linkRef.current[nextIndex]?.focus();
                            break;
                        case 'ArrowLeft':
                            event.preventDefault();
                            event.stopPropagation();
                            linkRef.current[prevIndex]?.focus();
                            break;
                        case 'Home':
                            event.preventDefault();
                            event.stopPropagation();
                            linkRef.current[0]?.focus();
                            break;
                        case 'End':
                            event.preventDefault();
                            event.stopPropagation();
                            linkRef.current[maxIndex]?.focus();
                            break;
                        default:
                            break;
                    }
                } }, link.text)),
        link.children.length > 0 ? (React.createElement(NavigationDropdown, { ...link, active: props.activeLink === link.id, activeTwo: props.activeTwo, activeThree: props.activeThree, onClose: () => props.setActiveLink(''), onHoverFirst: props.setActiveTwo, onHoverSecond: props.setActiveThree, site: props.site })) : null)))));
};
export default DesktopNavigation;
